// @ts-nocheck
import $ from 'jquery';
import _ from 'lodash';
import Highlighter from '@analytics/web-highlighter';
import './assest/styles/index.scss';
import { getOffsetMeta, checkLegalityUpward, checkLegalityDownward, getDuplicateId } from './scripts/utils';
import i18n from './scripts/i18n';
import EventEmitter from './scripts/event';
import { isIE } from '../../constants';
import { createPopper } from '@popperjs/core';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { PatsnapCopilotMessageSender } from '@analytics/patsnap-copilot/src/patsnap-copilot-message-sender';

const dynamicMenu = {
    addPopover: [],
    delPopover: [],
};

export default class ParagraphWording extends EventEmitter {
    // ⚠️⚠️⚠️ 划词相关静态属性 需要与底层组件库保持一致 不建议修改
    static rootClass = 'pt-paragraph-wording';

    static wordingClass = 'pt-wording';

    static wordingDataset = 'data-wording-id';

    static wordingExtraDataset = 'data-wording-id-extra';

    static mockSelectionId = 'mockSelection';

    static mockSelectionClass = 'mock-selection';

    static commentFlag = 'data-comment-count';

    static headerHeightBuffer = 64;

    static updateDynamicMenu = (menu, forceUpdate) => {
        if (menu.addPopover) {
            dynamicMenu.addPopover = forceUpdate ? menu.addPopover : [...dynamicMenu.addPopover, ...menu.addPopover];
        }
        if (menu.delPopover) {
            dynamicMenu.delPopover = forceUpdate ? menu.delPopover : [...dynamicMenu.delPopover, ...menu.delPopover];
        }
    };

    constructor({ root, cacheKey, lang = 'en', disabled = false, permission, cacheStore, customClass = [], minLength = 2, maxLength = 2000 }) {
        super();
        // 全局变量
        this.root = root;
        this.wrap_range = null;
        this.activeId = '';
        this.isHoverDeletePanel = false;
        this.isInTriggerArea = false;
        this.addWordingPopover = null;
        this.delWordingPopover = null;
        this.disposeAddWordingPopoverMenuEvent = () => {};
        this.disposeDelWordingPopoverMenuEvent = () => {};
        this.lang = lang;
        this.cacheStore = cacheStore || sessionStorage;
        this.cacheKey = cacheKey;
        this.delIdCacheKey = `${this.cacheKey}_del-list`;
        this.commentCountCacheKey = `${this.cacheKey}_count-list`;
        this.disabled = disabled;
        this.illegalInfo = {};
        this.minLength = minLength;
        this.maxLength = maxLength;
        this.isHasMockSelection = false;
        this.mockSelectionSource = {};
        this.tooltipPopperInstance = null;
        this.tooltipPopper = null;
        this.customClass = customClass;
        // 权限
        this.permission = permission || { read: false, edit: false, semantic: false, compare: false };
        // 非法标签校验列表
        this.illegalTagNameList = ['MATHS'];
        this.illegalClassNameList = [ParagraphWording.wordingClass, ...this.customClass];

        if (!this.root) return;

        // 给注册容器绑定划词事件以及样式
        $(this.root).addClass(ParagraphWording.rootClass);
        if (!this.permission.read) $(this.root).addClass(`${ParagraphWording.rootClass}__no-permission`);
        this.root.addEventListener('mousedown', this._eventRootMouseDown);
        this.root.addEventListener('mouseup', this._eventRootMouseUp);

        // 初始化划词实例
        this.wording = new Highlighter({
            $root: root,
            style: {
                className: [ParagraphWording.wordingClass, ...this.customClass],
            },
            excludeEleCallback: (node) => {
                // 前端高亮/服务端高亮 不是固定元素 会影响页面结构 需要跳过
                const isCustomHighlight = node.dataset['markjs'];
                const isServiceHighlight = node.getAttribute('class') && node.getAttribute('class').includes('patsnap-search-hit');
                return node && (isCustomHighlight || isServiceHighlight);
            },
        });

        // 绑定划词事件
        this.bindSelectionHover();
    }

    // root节点相关
    _eventRootMouseDown = (event) => {
        // 需要把鼠标右键复制功能放出
        if (event.button === 2) return;
        // 非法操作处理
        if (this.disabled || this._isTriggerInAddPopover(event)) return;
        this.isInTriggerArea = true;
        this.illegalInfo = {};
        this._cleanRange(true);
        // mockSelection 在每次重新划段时重置
        if (this.isHasMockSelection) this.cleanMockSelection();
    };

    _eventRootMouseUp = () => {
        // 需要把鼠标右键复制功能放出
        if (event.button === 2) return;

        // 非法操作处理
        if (this.disabled || !this.isInTriggerArea) {
            this.isInTriggerArea = false;
            return;
        }

        // 非空处理
        const selection = window.getSelection();
        const wrap_range = selection.anchorNode && selection.getRangeAt(0);
        if (!wrap_range || wrap_range.collapsed) {
            this.isInTriggerArea = false;
            return;
        }

        // selection起始点是否都在容器内部
        const rangeString = wrap_range.toString();
        const isStartInRoot = $.contains(this.root, wrap_range.startContainer) || this.root === wrap_range.startContainer;
        const isEndInRoot = $.contains(this.root, wrap_range.endContainer) || this.root === wrap_range.endContainer;
        if (!isStartInRoot || !isEndInRoot) {
            this.isInTriggerArea = false;
            return;
        }

        //_addWordingFromRange和_searchFromRange也会触发mouseUp事件
        this.isInTriggerArea = false;
        this.wrap_range = wrap_range.cloneRange();

        // 最小长度校验 ☆☆☆
        if (rangeString.length < this.minLength) {
            this.illegalInfo = { type: 'min-length', message: '选中内容少于最小限制' };
            this.$emit('illegal', this.illegalInfo);
            return;
        }

        // 最大长度校验 ☆☆☆
        if (rangeString.length > this.maxLength) {
            this.illegalInfo = { type: 'max-length', message: '选中内容多于最大限制' };
            this.$emit('illegal', this.illegalInfo);
            return;
        }

        // 校验是否为完全重复的选区 ☆☆☆
        if (_.isEmpty(this.illegalInfo)) {
            const duplicateId = getDuplicateId(this.root, this.wrap_range, ParagraphWording.wordingDataset);
            if (duplicateId && $(this.wording.getDoms(duplicateId)).text() === rangeString) {
                this.illegalInfo = { type: 'duplicate', message: '完全重复的选区' };
                this.$emit('illegal', this.illegalInfo);
            }
        }

        // 向上校验 判断划段落点是否合法 ☆☆☆
        if (_.isEmpty(this.illegalInfo)) {
            const isStartContainerLegality = checkLegalityUpward({
                root: this.root,
                checkNode: this.wrap_range.startContainer,
                illegalTagNameList: this.illegalTagNameList,
                illegalClassNameList: this.illegalClassNameList,
            });
            const isEndContainerLegality = checkLegalityUpward({
                root: this.root,
                checkNode: this.wrap_range.endContainer,
                illegalTagNameList: this.illegalTagNameList,
                illegalClassNameList: this.illegalClassNameList,
            });
            if (!isStartContainerLegality || !isEndContainerLegality) {
                if (!isStartContainerLegality && !isEndContainerLegality) {
                    this.illegalInfo = { type: 'start-and-end', message: '非支持的落点和起点' };
                } else if (!isStartContainerLegality) {
                    this.illegalInfo = { type: 'start', message: '非支持的起点' };
                } else {
                    this.illegalInfo = { type: 'end', message: '非支持的落点' };
                }
                this.$emit('illegal', this.illegalInfo);
                // wrap_range.collapse();
                // this.wrap_range = null;
                // return;
            }
        }

        // 向下校验 判断划段包含的内容是否合法 ☆☆☆
        if (_.isEmpty(this.illegalInfo)) {
            // 解决IE下DocumentFragment.children取不到
            let checkList = [];
            if (isIE) {
                const cloneContents = document.createElement('div');
                cloneContents.setAttribute('class', `${ParagraphWording.rootClass}__clone-contents`);
                document.body.appendChild(cloneContents);
                cloneContents.appendChild(this.wrap_range.cloneContents());
                checkList = cloneContents.cloneNode(true).children;
                $(cloneContents).remove();
            } else {
                checkList = this.wrap_range.cloneContents().children;
            }
            const isInnerContainerLegality = checkLegalityDownward({
                checkNodeList: checkList || [],
                illegalTagNameList: this.illegalTagNameList,
                illegalClassNameList: this.illegalClassNameList,
            });
            if (isInnerContainerLegality) {
                this.illegalInfo = { type: 'contain', message: '包含非支持的内容' };
                this.$emit('illegal', this.illegalInfo);
                // wrap_range.collapse();
                // this.wrap_range = null;
                // return;
            }
        }

        // 计算popper位置
        const wrapRangeClientRectList = this.wrap_range.getClientRects();
        const wrapRangeClientRect = wrapRangeClientRectList[wrapRangeClientRectList.length - 1];
        const containerClientRect = this.root.getBoundingClientRect();
        const top = wrapRangeClientRect.bottom - containerClientRect.top - 4;
        const left = wrapRangeClientRect.right - containerClientRect.left + 4;

        // 解决IE/Edge下拖蓝异常
        setTimeout(() => {
            this._createAddPopover({ top, left });
        }, 0);

        // 防止标签重叠，add优先级高
        if (this.delWordingPopover) this._destroyDelPopover();
    };

    // 划词节点相关
    _eventWordingHover = (item, wording, event) => {
        // 防止标签重叠，add优先级高
        if (!this.permission.read || this.addWordingPopover || this.isInTriggerArea || this.disabled || item.id === ParagraphWording.mockSelectionId) return;

        this.activeId = item.id;
        this.isHoverDeletePanel = true;

        this.wording.addClass('active', this.activeId);

        const containerClientRect = this.root.getBoundingClientRect();
        // 是否跟随鼠标位置?
        // const targetClientRect = event.target.getBoundingClientRect();
        // const top = targetClientRect.top - containerClientRect.top - 30;
        const top = event.pageY - containerClientRect.top;
        const left = event.pageX - containerClientRect.left;
        this._createDelPopover({ top, left });
    };

    _eventWordingHoverOut = item => {
        if (!this.permission.read) return;
        this.isHoverDeletePanel = false;
        this.wording.removeClass('active', item.id);
        setTimeout(() => {
            if (!this.isHoverDeletePanel) {
                this.activeId = '';
                this._destroyDelPopover();
            }
        }, 300);
    };

    _eventWordingCreate = ({ sources, type }) => {
        if (type !== 'from-input') return;
        if (_.get(sources, '[0].id') === ParagraphWording.mockSelectionId) return this.mockSelectionSource = sources[0];
        // 添加至前端缓存
        this._batchAddStorage(sources);
    };

    // 生成划词选框相关
    _createAddPopover = ({ top, left }) => {
        if (this.addWordingPopover) {
            this._destroyAddPopover();
        }
        const container = document.createElement('div');
        const element = document.createElement('div');
        container.setAttribute('class', `${ParagraphWording.rootClass}__add ${ParagraphWording.rootClass}__popover`);
        element.setAttribute('class', `${ParagraphWording.rootClass}__popover-inner`);
        const underline = $(`<p class="${ParagraphWording.rootClass}__add-wording ${ParagraphWording.rootClass}__popover-item">
                                <span class="${ParagraphWording.rootClass}__popover-icon ${ParagraphWording.rootClass}__popover-icon--underline"></span>
                                <span class="${ParagraphWording.rootClass}__popover-text">${i18n[this.lang]['underline']}</span>
                             </p>`);
        const similar = $(`<p class="${ParagraphWording.rootClass}__add-search ${ParagraphWording.rootClass}__popover-item">
                                <span class="${ParagraphWording.rootClass}__popover-icon ${ParagraphWording.rootClass}__popover-icon--search"></span>
                                <span class="${ParagraphWording.rootClass}__popover-text">${i18n[this.lang]['similar']}</span>
                           </p>`);
        const comment = $(`<p class="${ParagraphWording.rootClass}__add-comment ${ParagraphWording.rootClass}__popover-item">
                                <span class="${ParagraphWording.rootClass}__popover-icon ${ParagraphWording.rootClass}__popover-icon--comment"></span>
                                <span class="${ParagraphWording.rootClass}__popover-text">${i18n[this.lang]['comment']}</span>
                           </p>`);
        const compare = $(`<p class="${ParagraphWording.rootClass}__add-compare ${ParagraphWording.rootClass}__popover-item">
                                <span class="${ParagraphWording.rootClass}__popover-icon ${ParagraphWording.rootClass}__popover-icon--compare"></span>
                                <span class="${ParagraphWording.rootClass}__popover-text">${i18n[this.lang]['compare']}</span>
                           </p>`);
        const tooltip = $(`<p class="${ParagraphWording.rootClass}__tooltip ${ParagraphWording.rootClass}__popover-item">
                                <span class="${ParagraphWording.rootClass}__popover-text">${i18n[this.lang]['title']}</span>
                                <span class="${ParagraphWording.rootClass}__popover-icon ${ParagraphWording.rootClass}__popover-icon--tooltip"></span>
                           </p>`);
        // 根据权限生成popover内容
        const hasCommentAcl = _.isEmpty(this.illegalInfo) && this.permission.edit;
        const hasSemanticAcl = this.permission.semantic;
        const hasCompareAcl = _.isEmpty(this.illegalInfo) && this.permission.compare;
        if (!hasCommentAcl && !hasSemanticAcl && !hasCompareAcl) return;
        if (hasCommentAcl) {
            $(element).append(underline);
            $(element).append(comment);
        }
        if (hasSemanticAcl) {
            $(element).append(similar);
        }
        if (hasCompareAcl) {
            $(element).append(compare);
        } else {
            $(element).prepend(tooltip);
        }
        $(container).append(element);
        // 动态追加菜单项
        this.disposeAddWordingPopoverMenuEvent = this._appendMenuInAddPopover(element);
        // 追加popover
        this.addWordingPopover = container;
        this.root.appendChild(this.addWordingPopover);
        this._bindAddPopoverEvents();
        this._updatePopoverPosition(top, left, 'add');
        this._createTooltipPopper();
        this.$emit('popoverVisibleChange', { type: 'add', position: { top, left } });
    };

    _destroyAddPopover = () => {
        if (!this.addWordingPopover) return;
        this._unBindAddPopoverEvents();
        $(this.addWordingPopover).remove();
        this.addWordingPopover = null;
        this._destroyTooltipPopper();
        this.disposeAddWordingPopoverMenuEvent();
    };

    _appendMenuInAddPopover = (container) => {
        const menu = dynamicMenu.addPopover || [];
        const disposeList = [];
        menu.forEach(item => {
            // 创建节点
            const element = $(`<p class="${ParagraphWording.rootClass}__add-${item.key} ${ParagraphWording.rootClass}__popover-item">
                                <span class="${ParagraphWording.rootClass}__popover-icon ${ParagraphWording.rootClass}__popover-icon--${item.key}">${item.icon}</span>
                                <span class="${ParagraphWording.rootClass}__popover-text">${item.label}</span>
                           </p>`);
            $(container).append(element);
            // 绑定处理函数
            const defaultHandler = () => {
                event.stopPropagation();
                const matchedText = this.wrap_range.toString();
                item.callback(matchedText);
                this._destroyAddPopover();
                this._cleanRange(true);
            };
            $('body').delegate(`.${ParagraphWording.rootClass}__add-${item.key}`, 'click', defaultHandler);
            // 绑定解绑函数
            const dispose = () => $('body').undelegate(`.${ParagraphWording.rootClass}__add-${item.key}`, 'click', defaultHandler);
            disposeList.push(dispose);
        });
        return () => disposeList.forEach(fn => fn());
    };

    _bindAddPopoverEvents = () => {
        document.body.addEventListener('mousedown', this._eventAddPopoverClickOutside);
        // 确保在AddPopover中的所有点击为有效点击 任意点击（会触发Selection的change）
        // 由于元素绑定依赖delegate 故无法直接给‘this.addWordingPopover’绑定click时间
        $('body').delegate(`.${ParagraphWording.rootClass}__add`, 'click', this._destroyAddPopover);
        // 基础功能
        $(this.addWordingPopover).delegate(`.${ParagraphWording.rootClass}__add-wording`, 'click', this._addWordingFromRange);
        $(this.addWordingPopover).delegate(`.${ParagraphWording.rootClass}__add-search`, 'click', this._searchFromRange);
        $(this.addWordingPopover).delegate(`.${ParagraphWording.rootClass}__add-copilot`, 'click', this._sendToCopilot);
        $(this.addWordingPopover).delegate(`.${ParagraphWording.rootClass}__add-comment`, 'click', this._commentFromRange);
        $(this.addWordingPopover).delegate(`.${ParagraphWording.rootClass}__add-compare`, 'click', this._compareFromRange);
        // tooltip相关
        $(this.addWordingPopover).delegate(`.${ParagraphWording.rootClass}__tooltip .${ParagraphWording.rootClass}__popover-icon`, 'mouseenter', this._showTooltipPopper);
        $(this.addWordingPopover).delegate(`.${ParagraphWording.rootClass}__tooltip .${ParagraphWording.rootClass}__popover-icon`, 'mouseleave', this._hideTooltipPopper);
    };

    _unBindAddPopoverEvents = () => {
        document.body.removeEventListener('mousedown', this._eventAddPopoverClickOutside);
        $('body').undelegate(`.${ParagraphWording.rootClass}__add`, 'click', this._destroyAddPopover);
        // 基础功能
        $(this.addWordingPopover).undelegate(`.${ParagraphWording.rootClass}__add-wording`, 'click', this._addWordingFromRange);
        $(this.addWordingPopover).undelegate(`.${ParagraphWording.rootClass}__add-search`, 'click', this._searchFromRange);
        $(this.addWordingPopover).undelegate(`.${ParagraphWording.rootClass}__add-copilot`, 'click', this._sendToCopilot);
        $(this.addWordingPopover).undelegate(`.${ParagraphWording.rootClass}__add-comment`, 'click', this._commentFromRange);
        $(this.addWordingPopover).undelegate(`.${ParagraphWording.rootClass}__add-compare`, 'click', this._compareFromRange);
        // tooltip相关
        $(this.addWordingPopover).undelegate(`.${ParagraphWording.rootClass}__tooltip .${ParagraphWording.rootClass}__popover-icon`, 'mouseenter', this._showTooltipPopper);
        $(this.addWordingPopover).undelegate(`.${ParagraphWording.rootClass}__tooltip .${ParagraphWording.rootClass}__popover-icon`, 'mouseleave', this._hideTooltipPopper);
    };

    _eventAddPopoverClickOutside = event => {
        const isContains = this._isTriggerInAddPopover(event);
        if (isContains) return;
        this._destroyAddPopover();
    };

    _isTriggerInAddPopover = event => {
        const parent = this.addWordingPopover;
        if (!parent) return false;
        return $.contains(parent, event.target) || parent === event.target;
    };

    _addWordingFromRange = event => {
        event.stopPropagation();
        this._destroyAddPopover();
        // 需要基于服务端的 tag , 重新计算 offset 给 service 存储使用
        let offsetMeta = getOffsetMeta(this.wrap_range, this.root);
        // Fix双击后由于接口返回有延迟，导致的range变化
        const wrap_range = this.wrap_range.cloneRange();
        // Fix火狐三击全中整段后造成的Range中endOffset信息错误
        if (offsetMeta.endMeta.estimate_offset < offsetMeta.startMeta.estimate_offset) {
            const lastTextNode = _.get(wrap_range.endContainer, 'lastChild', wrap_range.endContainer);
            const lastTextLength = _.get(wrap_range.endContainer, 'lastChild.textContent.length', 0);
            wrap_range.setEnd(lastTextNode, lastTextLength);
            offsetMeta = getOffsetMeta(wrap_range, this.root);
        }
        const next = wordingId => {
            this.wording.fromRange(wrap_range, wordingId);
            this._cleanRange(true);
        };
        this.$emit('create', offsetMeta, next);
    };

    _sendToCopilot = event => {
        event.stopPropagation();
        const matchedText = this.wrap_range.toString();
        const sender = injectService<PatsnapCopilotMessageSender>(PatsnapCopilotMessageSender);
        console.log('sendToCopilot', matchedText, sender);
        sender.sendMessage({
            text: matchedText,
            replyId: '',
            needCheckWordsLimit: true,
        });
        this._destroyAddPopover();
        this._cleanRange(true);
    };

    _searchFromRange = event => {
        event.stopPropagation();
        const matchedText = this.wrap_range.toString();
        this.$emit('searchText', matchedText);
        this._destroyAddPopover();
        this._cleanRange(true);
    };

    _compareFromRange = () => {
        event.stopPropagation();
        this._destroyAddPopover();
        // 需要基于服务端的 tag , 重新计算 offset 给 service 存储使用
        let offsetMeta = getOffsetMeta(this.wrap_range, this.root);
        // Fix双击后由于接口返回有延迟，导致的range变化
        const wrap_range = this.wrap_range.cloneRange();
        // Fix火狐三击全中整段后造成的Range中endOffset信息错误
        if (offsetMeta.endMeta.estimate_offset < offsetMeta.startMeta.estimate_offset) {
            const lastTextNode = _.get(wrap_range.endContainer, 'lastChild', wrap_range.endContainer);
            const lastTextLength = _.get(wrap_range.endContainer, 'lastChild.textContent.length', 0);
            wrap_range.setEnd(lastTextNode, lastTextLength);
            offsetMeta = getOffsetMeta(wrap_range, this.root);
        }
        const next = wordingId => {
            this.wording.fromRange(wrap_range, wordingId);
            this._cleanRange(true);
        };
        this.$emit('compare', {
            text: offsetMeta?.fullText,
            next,
        });

    };

    _commentFromRange = event => {
        event.stopPropagation();
        // 用于定位addComment弹框位置
        const wrapRangeClientRectList = this.wrap_range.getClientRects();
        const wrapRangeClientRect = wrapRangeClientRectList[wrapRangeClientRectList.length - 1];
        const triggerPosition = { top: wrapRangeClientRect.bottom - ParagraphWording.headerHeightBuffer, left: wrapRangeClientRect.right };

        this._destroyAddPopover();
        const offsetMeta = getOffsetMeta(this.wrap_range, this.root);

        this._setMockSelectionFromRange();

        const next = (wordingId, commentId) => this._setCommentByMockSelection(wordingId, commentId);
        this.$emit('comment', { type: 'add', offsetMeta, triggerPosition }, next);
    };

    _createTooltipPopper = () => {
        this.tooltipPopper = $(`<p class="${ParagraphWording.rootClass}__tooltip-content">${i18n[this.lang]['tooltip']}</p>`);
        $(`.${ParagraphWording.rootClass}__tooltip-content`).remove();
        $('body').append(this.tooltipPopper);
        const reference = this.addWordingPopover.querySelector(`.${ParagraphWording.rootClass}__tooltip .${ParagraphWording.rootClass}__popover-icon`);
        const content = this.tooltipPopper[0];
        this.tooltipPopperInstance = createPopper(reference, content, {
            placement: 'bottom-start',
            strategy: 'fixed',
            modifiers: [{ name: 'offset', options: { offset: [4, 4] } }],
        });
    };

    _destroyTooltipPopper = () => {
        $(this.tooltipPopper).remove();
        this.tooltipPopper = null;
        if (!this.tooltipPopperInstance) return;
        this.tooltipPopperInstance.destroy();
        this.tooltipPopperInstance = null;
    };

    _showTooltipPopper = () => {
        this.tooltipPopperInstance.update();
        this.tooltipPopper.show();
    };

    _hideTooltipPopper = () => {
        this.tooltipPopper.hide();
    };

    // 取消划词选框相关
    _createDelPopover = ({ top, left }) => {
        if (this.delWordingPopover) {
            this._destroyDelPopover();
        }
        const container = document.createElement('div');
        const element = document.createElement('div');
        const commentCount = this._getCommentCount(this.activeId);
        const hasComment = commentCount > 0;
        container.setAttribute('class', `${ParagraphWording.rootClass}__remove ${ParagraphWording.rootClass}__popover`);
        element.setAttribute('class', `${ParagraphWording.rootClass}__popover-inner`);
        const cancel = $(`<p class="${ParagraphWording.rootClass}__remove-cancel ${ParagraphWording.rootClass}__popover-item">
                                <span class="${ParagraphWording.rootClass}__popover-icon ${ParagraphWording.rootClass}__popover-icon--cancel"></span>
                                <span class="${ParagraphWording.rootClass}__popover-text">${i18n[this.lang]['cancel']}</span>
                          </p>`);
        const similar = $(`<p class="${ParagraphWording.rootClass}__remove-search ${ParagraphWording.rootClass}__popover-item">
                                <span class="${ParagraphWording.rootClass}__popover-icon ${ParagraphWording.rootClass}__popover-icon--search"></span>
                                <span class="${ParagraphWording.rootClass}__popover-text">${i18n[this.lang]['similar']}</span>
                           </p>`);
        const comment = $(`<p class="${ParagraphWording.rootClass}__remove-comment ${ParagraphWording.rootClass}__popover-item">
                                <span class="${ParagraphWording.rootClass}__popover-icon ${ParagraphWording.rootClass}__popover-icon--comment"></span>
                                <span class="${ParagraphWording.rootClass}__popover-text">${hasComment ? i18n[this.lang]['viewComment'] : i18n[this.lang]['comment']}${hasComment ? ` (${commentCount})` : ''}</span>
                           </p>`);
        // 根据权限生成popover内容
        const hasCancelAcl = !hasComment && this.permission.edit;
        const hasCommentAcl = this.permission.edit || (hasComment && this.permission.read);
        const hasSemanticAcl = this.permission.read && this.permission.semantic;
        if (!hasCancelAcl && !hasCommentAcl && !hasSemanticAcl) return;
        if (hasCancelAcl) {
            $(element).append(cancel);
        }
        if (hasCommentAcl) {
            $(element).append(comment);
        }
        if (hasSemanticAcl) {
            $(element).append(similar);
        }
        $(container).append(element);
        // 动态追加菜单项
        this.disposeDelWordingPopoverMenuEvent = this._appendMenuInDelPopover(element);
        // 追加popover
        this.delWordingPopover = container;
        this.root.appendChild(this.delWordingPopover);
        // 快捷注释需要append后获取最新高度
        const tagHeight = $(this.delWordingPopover).outerHeight();
        this._bindDelPopoverEvents();
        // 更新偏移量
        this._updatePopoverPosition(top - tagHeight - 2, left - 30, 'del');
    };

    _destroyDelPopover = () => {
        if (!this.delWordingPopover) return;
        this._unBindDelPopoverEvents();
        $(this.delWordingPopover).remove();
        this.delWordingPopover = null;
        this.disposeDelWordingPopoverMenuEvent();
    };

    _appendMenuInDelPopover = (container) => {
        const menu = dynamicMenu.delPopover || [];
        const disposeList = [];
        menu.forEach(item => {
            // 创建节点
            const element = $(`<p class="${ParagraphWording.rootClass}__remove-${item.key} ${ParagraphWording.rootClass}__popover-item">
                                <span class="${ParagraphWording.rootClass}__popover-icon ${ParagraphWording.rootClass}__popover-icon--${item.key}">${item.icon}</span>
                                <span class="${ParagraphWording.rootClass}__popover-text">${item.label}</span>
                           </p>`);
            $(container).append(element);
            // 绑定处理函数
            const defaultHandler = () => {
                const matchedEl = this.wording.getDoms(this.activeId);
                const matchedText = $(matchedEl).text();
                item.callback(matchedText);
                this.activeId = '';
                this.wording.removeClass('active', this.activeId);
                this._destroyDelPopover();
            };
            $('body').delegate(`.${ParagraphWording.rootClass}__remove-${item.key}`, 'click', defaultHandler);
            // 绑定解绑函数
            const dispose = () => $('body').undelegate(`.${ParagraphWording.rootClass}__remove-${item.key}`, 'click', defaultHandler);
            disposeList.push(dispose);
        });
        return () => disposeList.forEach(fn => fn());
    };

    _bindDelPopoverEvents = () => {
        // 鼠标事件
        this.delWordingPopover.addEventListener('mouseenter', this._eventDelPopoverMouseenter);
        this.delWordingPopover.addEventListener('mouseleave', this._eventDelPopoverMouseleave);
        // 点击事件
        $(this.delWordingPopover).delegate(`.${ParagraphWording.rootClass}__remove-cancel`, 'click', this._removeWording);
        $(this.delWordingPopover).delegate(`.${ParagraphWording.rootClass}__remove-search`, 'click', this._searchFromWording);
        $(this.delWordingPopover).delegate(`.${ParagraphWording.rootClass}__remove-comment`, 'click', this._commentFromWording);
    };

    _unBindDelPopoverEvents = () => {
        // 鼠标事件
        this.delWordingPopover.removeEventListener('mouseenter', this._eventDelPopoverMouseenter);
        this.delWordingPopover.removeEventListener('mouseleave', this._eventDelPopoverMouseleave);
        // 点击事件
        $(this.delWordingPopover).undelegate(`.${ParagraphWording.rootClass}__remove-cancel`, 'click', this._removeWording);
        $(this.delWordingPopover).undelegate(`.${ParagraphWording.rootClass}__remove-search`, 'click', this._searchFromWording);
        $(this.delWordingPopover).undelegate(`.${ParagraphWording.rootClass}__remove-comment`, 'click', this._commentFromWording);
    };

    _eventDelPopoverMouseenter = () => {
        this.isHoverDeletePanel = true;
        this.wording.addClass('active', this.activeId);
    };

    _eventDelPopoverMouseleave = () => {
        this.isHoverDeletePanel = false;
        this.wording.removeClass('active', this.activeId);
        this._destroyDelPopover();
    };

    _removeWording = _.debounce(() => {
        const next = activeId => {
            if (!activeId) return this.activeId = '';
            // 需要先移除样式，再移除id
            this.wording.removeClass('active', activeId);
            this.wording.remove(activeId);
            // 移除前端缓存
            this._deleteStorageById(activeId);
            this._updateDeletedIdList(activeId);
            this.activeId = '';
            // 需要移除划词后再移除popover 否则会再次触发hover
            this._destroyDelPopover();
        };
        this.$emit('remove', this.activeId, next);
    }, 200);

    _searchFromWording = () => {
        const matchedEl = this.wording.getDoms(this.activeId);
        const matchedText = $(matchedEl).text();
        this.$emit('searchText', matchedText);
        this.activeId = '';
        this.wording.removeClass('active', this.activeId);
        this._destroyDelPopover();
    };

    _commentFromWording = () => {
        const activeId = this.activeId;
        const matched = this._get$DomsById(activeId)[0];
        // 新增 OR 回复
        const hasComment = this._getCommentCount(activeId) > 0;
        // 用于定位addComment弹框位置
        const matchedRangeClientRectList = matched.getClientRects();
        const matchedClientRect = matchedRangeClientRectList[matchedRangeClientRectList.length - 1];
        const matchedBoundingClientRect = matched.getBoundingClientRect();
        const triggerPosition = { top: matchedBoundingClientRect.bottom - ParagraphWording.headerHeightBuffer, left: matchedClientRect.right };

        const next = (wordingId, commentId) => this._setCommentByWording(wordingId, commentId);
        const offsetMeta = { fullText: $(this.wording.getDoms(activeId)).text() };

        if (!hasComment) this._setMockSelectionFromWording();
        this.$emit('comment', { type: (hasComment ? 'reply' : 'add'), wordingId: activeId, offsetMeta, triggerPosition }, next);

        this.activeId = '';
        this.wording.removeClass('active', this.activeId);
        this._destroyDelPopover();
    };

    // mockSelection相关
    _setMockSelectionFromRange = () => {
        this.isHasMockSelection = true;
        this.wording.fromRange(this.wrap_range, ParagraphWording.mockSelectionId);
        this.wording.addClass(ParagraphWording.mockSelectionClass, ParagraphWording.mockSelectionId);
        this._destroyAddPopover();
        this._cleanRange(true);
    };

    _setMockSelectionFromWording = () => {
        this.isHasMockSelection = true;
        this.wording.addClass(ParagraphWording.mockSelectionClass, this.activeId);
        this._destroyAddPopover();
        this._cleanRange(true);
    };

    cleanMockSelection = () => {
        this.isHasMockSelection = false;
        this.wording.removeClass(ParagraphWording.mockSelectionClass);
        this.wording.remove(ParagraphWording.mockSelectionId);
    };

    _setCommentByMockSelection = (wordingId, commentId) => {
        if (!this.wording) return;
        this.wording.removeClass(ParagraphWording.mockSelectionClass);
        const mock = this._get$DomsById(ParagraphWording.mockSelectionId);
        mock.attr({ [ParagraphWording.wordingDataset]: wordingId, [ParagraphWording.commentFlag]: 1 });
        this._updateCommentCountMap(wordingId, 1, 'add');
        // 写入缓存
        this._batchAddStorage([{ ...this.mockSelectionSource, id: wordingId }]);
        this.mockSelectionSource = {};
    };

    _setCommentByWording = (wordingId, commentId) => {
        const matched = this._get$DomsById(wordingId);
        matched.attr({ [ParagraphWording.wordingDataset]: wordingId, [ParagraphWording.commentFlag]: 1 });
        this._updateCommentCountMap(wordingId, 1, 'add');
    };

    _getCommentCount = (wordingId) => {
        const matched = this._get$DomsById(wordingId)[0];
        const matchedCount = matched.getAttribute(ParagraphWording.commentFlag);
        return matchedCount ? Number.parseInt(matchedCount) : 0;
    };

    // 缓存相关
    _batchAddStorage = sources => {
        const wordingCache = this.cacheStore.getItem(this.cacheKey) ? JSON.parse(this.cacheStore.getItem(this.cacheKey)) : [];
        wordingCache.push(...sources);
        this.cacheStore.setItem(this.cacheKey, JSON.stringify(wordingCache));
    };

    _deleteStorageById = deleteIndex => {
        const wordingCache = this.cacheStore.getItem(this.cacheKey) ? JSON.parse(this.cacheStore.getItem(this.cacheKey)) : [];
        const matchedIndex = wordingCache.findIndex(item => item.id === deleteIndex);
        wordingCache.splice(matchedIndex, 1);
        this.cacheStore.setItem(this.cacheKey, JSON.stringify(wordingCache));
    };

    _updateDeletedIdList = id => {
        const delIdListCache = this.cacheStore.getItem(this.delIdCacheKey) ? JSON.parse(this.cacheStore.getItem(this.delIdCacheKey)) : [];
        delIdListCache.push(id);
        this.cacheStore.setItem(this.delIdCacheKey, JSON.stringify(delIdListCache));
    };

    _updateCommentCountMap = (key, val, type) => {
        const countListMap = this.cacheStore.getItem(this.commentCountCacheKey) ? JSON.parse(this.cacheStore.getItem(this.commentCountCacheKey)) : {};
        if (type === 'add') {
            countListMap[key] = val;
        } else {
            delete countListMap[key];
        }
        this.cacheStore.setItem(this.commentCountCacheKey, JSON.stringify(countListMap));
    };

    resetStorage = () => {
        // disable 下不会生成 wording 实例
        if (!this.wording) return;
        const wordingCache = this.cacheStore.getItem(this.cacheKey) ? JSON.parse(this.cacheStore.getItem(this.cacheKey)) : [];
        const delIdListCache = this.cacheStore.getItem(this.delIdCacheKey) ? JSON.parse(this.cacheStore.getItem(this.delIdCacheKey)) : [];
        const countListMapCache = this.cacheStore.getItem(this.commentCountCacheKey) ? JSON.parse(this.cacheStore.getItem(this.commentCountCacheKey)) : {};
        if (delIdListCache.length) {
            delIdListCache.forEach(id => this.wording.remove(id));
        }
        if (wordingCache.length) {
            wordingCache.forEach(item => {
                // 在刷新接口后，this.cacheStore 不会清除，需要保不会重复恢复
                const isAlreadyExistInFe = this._get$DomsById(item.id).length > 0;
                const isInDelIdList = delIdListCache.includes(item.id);
                if (!isAlreadyExistInFe && !isInDelIdList) this.wording.fromStore(item.startMeta, item.endMeta, item.text, item.id);
            });
        }
        if (!_.isEmpty(countListMapCache)) {
            _.forEach(countListMapCache, (val, key) => {
                const matchedEl = this._get$DomsById(key);
                matchedEl.attr({ [ParagraphWording.commentFlag]: val });
            });
        }
    };

    // count 相关
    updateCommentCount = (id, count) => {
        const matchedEl = this._get$DomsById(id);
        const matchedCase = `.${ParagraphWording.rootClass}__remove.${ParagraphWording.rootClass}__popover .${ParagraphWording.rootClass}__remove-comment .${ParagraphWording.rootClass}__popover-text`;
        const $alreadyExistCountInPopover = $(this.root).find(matchedCase);
        if (!matchedEl.length) return;
        if (count !== 0) {
            matchedEl.attr({ [ParagraphWording.commentFlag]: count });
            this._updateCommentCountMap(id, count, 'add');
            // 如果取消划词选框未消除，需要更新count
            if ($alreadyExistCountInPopover.length) $alreadyExistCountInPopover.text(`${i18n[this.lang]['viewComment']} (${count})`);
        } else {
            // 如果count为0时 需要移除标签
            matchedEl.removeAttr(ParagraphWording.commentFlag);
            this._updateCommentCountMap(id, count, 'del');
            this.wording.remove(id);
            this._deleteStorageById(id);
            this._updateDeletedIdList(id);
            // 如果取消划词选框未消除，需要强制移除
            if ($alreadyExistCountInPopover.length) this._destroyDelPopover();
        }
    };

    // 其他
    _get$DomsById = findId => {
        // TODO: 后期如果支持交叉则需要修改逻辑
        const hitTag = `[${ParagraphWording.wordingDataset}=${findId}]`;
        let selector = `.${ParagraphWording.wordingClass}${hitTag}`;
        this.customClass.forEach(className => selector += `, .${className}${hitTag}`);
        const domList = $(this.root).find(selector);
        return domList;
    };

    _get$ExtraDomsById = findId => {
        const hitTag = `[${ParagraphWording.wordingExtraDataset}]`;
        let selector = `.${ParagraphWording.wordingClass}${hitTag}`;
        this.customClass.forEach(className => selector += `, .${className}${hitTag}`);
        const domListHasExtraAttr = $(this.root).find(selector);
        const domList = domListHasExtraAttr.filter((index, item) => {
            const extraId = $(item).attr(ParagraphWording.wordingExtraDataset);
            return extraId && extraId.includes(findId);
        });
        return domList;
    };

    _cleanRange = (deep = false) => {
        const selection = window.getSelection();
        const wrap_range = selection.anchorNode && selection.getRangeAt(0);
        selection && selection.collapse(this.root, 0);
        wrap_range && wrap_range.collapse(this.root, 0);
        if (deep) this.wrap_range = null;
    };

    _updatePopoverPosition = (top, left, type) => {
        const tag = (type === 'add') ? this.addWordingPopover : this.delWordingPopover;
        const tagWidth = $(tag).outerWidth();
        const tagHeight = $(tag).outerHeight();
        const containerWidth = $(this.root).width();
        const containerHeight = $(this.root).height();
        const documentWidth = $('body').width();
        const documentHeight = $('body').height();

        // 显示区域高度不足 需要换定位实现
        const isTagOverflow = tagHeight > containerHeight;
        if (isTagOverflow && type === 'add') {
            const wrapRangeClientRectList = this.wrap_range.getClientRects();
            const wrapRangeClientRect = wrapRangeClientRectList[wrapRangeClientRectList.length - 1];
            const fixTop = (tagHeight + wrapRangeClientRect.bottom - 4) > documentHeight ? 'auto' : wrapRangeClientRect.bottom - 4;
            const fixBottom = fixTop === 'auto' ? 4 : 'auto';
            const fixLeft = (tagWidth + wrapRangeClientRect.right + 4) > documentWidth ? 'auto' : wrapRangeClientRect.right + 4;
            const fixRight = fixLeft === 'auto' ? 4 : 'auto';
            $(tag).css({ top: fixTop, bottom: fixBottom, left: fixLeft, right: fixRight, display: 'block', position: 'fixed', 'z-index': 999 });
            return;
        }
        if (isTagOverflow && type === 'del') {
            const containerClientRect = this.root.getBoundingClientRect();
            const fixTop = (top + containerClientRect.top) < 4 ? 4 : top + containerClientRect.top;
            const fixLeft = (tagWidth + left + containerClientRect.left) > documentWidth ? 'auto' : left + containerClientRect.left;
            const fixRight = fixLeft === 'auto' ? 4 : 'auto';
            $(tag).css({ top: fixTop, left: fixLeft, right: fixRight, display: 'block', position: 'fixed', 'z-index': 999 });
            return;
        }

        // 保证 popper 不超出上下边界
        let updateTop = top < 0 ? 0 : top;
        if (top + tagHeight > containerHeight) {
            updateTop = containerHeight - tagHeight;
        }

        // 保证 popper 不超出左右边界
        if (containerWidth <= left + tagWidth) {
            $(tag).css({ top: updateTop, left: 'auto', right: 0, display: 'block' });
        } else if (left <= 0) {
            $(tag).css({ top: updateTop, left: 0, right: 'auto', display: 'block' });
        } else {
            $(tag).css({ top: updateTop, left, right: 'auto', display: 'block' });
        }
    };

    dispose = () => {
        if (this.root) {
            this.root.removeEventListener('mousedown', this._eventRootMouseDown);
            this.root.removeEventListener('mouseup', this._eventRootMouseUp);
            this.root = null;
        }
        if (this.wording) {
            this.wording.dispose();
            this.wording = null;
        }
    };

    bindSelectionHover() {
        this.wording
            .on('selection:hover', this._eventWordingHover)
            .on('selection:hover-out', this._eventWordingHoverOut)
            .on('selection:create', this._eventWordingCreate);
    }

    unbindSelectionHover() {
        this.wording
            .off('selection:hover', this._eventWordingHover)
            .off('selection:hover-out', this._eventWordingHoverOut)
            .off('selection:create', this._eventWordingCreate);
    }
}
